import { useGetUserInfoQuery } from "../../../app/rootReducer";
import { JSX } from "react";

interface Props {
    text: string;
    onClick?: () => void;
}

export const Tooltip = (props: Props): JSX.Element => {
    const { data } = useGetUserInfoQuery();
    const { languages } = data || { languages: [] };

    return (
        <div
            onClick={props.onClick}
            className="c-tooltip"
            style={{ width: languages.length <= 1 ? "100%" : "" }}
        >
            <img src="/images/info.svg" alt="tooltip" />
            <span className="tooltiptext">{props.text}</span>
        </div>
    );
};
